import axios from '../../service/index';
import { baseUrl } from '../config';

export default {
  getGsnPageUrlInfo: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/multilingual/getGsnPageUrlInfo.do`,
      params
    );
  },
  // 在线商城底部通知
  getDAnnouncementList: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/getDAnnouncementList.do`,
      params
    );
  },
  // 弹框提示
  getContextObjectAndRemark: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/public/getContextObjectAndRemark.do`,
      params
    );
  },
  // 关闭弹框
  cancelContext: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/cancelContext.do`,
      params
    );
  },
  // 修改密码提交
  changePassword: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/public/changePassword.do`,
      params
    );
  },
  // 修改名称提交
  upadateRealname: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/public/upadateRealname.do`,
      params
    );
  },
  // 廉洁责任书提交
  changeAgreement: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/changeAgreement.do`,
      params
    );
  },
  // 煤炭应用协同获取地址
  getCoalSupplySynergyUrl: (params) => {
    return axios.get(
      `${baseUrl}/memberportal/zh/companySouthwestRegion/getCoalSupplySynergyUrl.do?configUrlType=${params.configUrlType}`
    );
  },
  // 弱口令
  weakPasswordCheck: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/personage/register/interface/weakPasswordCheck.do`,
      params
    );
  },
  // 合规承诺函提交
  saveAgreementConformance: (params) => {
    return axios.post(
      `${baseUrl}/memberportal/zh/api/memberCenter/homepage/saveAgreementConformance.do`,
      params
    );
  },
};
